import React, { useState, useEffect } from 'react';

const VelaroSplash = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFadeOut(true), 2200);
    const done = setTimeout(() => onComplete(), 2800);
    return () => { clearTimeout(timer); clearTimeout(done); };
  }, [onComplete]);

  return (
    <div className={`fixed inset-0 z-[9999] bg-[#050505] flex items-center justify-center transition-opacity duration-500 ${fadeOut ? 'opacity-0' : 'opacity-100'}`} data-testid="velaro-splash">
      <div className="flex flex-col items-center gap-6">
        <img
          src="https://customer-assets.emergentagent.com/job_velaro-concierge/artifacts/kfkog7o3_VELARO%20LOGO%20PNG.png"
          alt="Velaro"
          className="h-20 w-auto velaro-pulse-glow"
        />
        <span className="text-white text-2xl tracking-[0.5em] uppercase velaro-pulse-glow" style={{ fontFamily: 'Outfit, sans-serif' }}>VELARO</span>
      </div>
    </div>
  );
};

export default VelaroSplash;
